import axiosInstance from "services/AxiosInstance";

export const deleteCustomField = async ({ customFieldId }: { customFieldId: string }): Promise<string> => {
  await axiosInstance.delete(`/customfields/${customFieldId}`);
  return customFieldId;
};
